export default "__VITE_ASSET__D2NywpMT__"